import RequestAbstract from "../abstract";

export default class CoinCurrencyPairs extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/coin-currency-pairs";
    }
}
